import React from 'react';

import { cn } from '@app/shared/utils/common';

export type ImageWithBackgroundVariant = 'blue' | 'orange';

interface ImageWithBackgroundProps {
  variant: ImageWithBackgroundVariant;
  children: React.ReactNode;
}

const VARIANT_TO_STYLES_MAP: Record<
  ImageWithBackgroundVariant,
  { firstBoxClassNames: string; secondBoxClassNames: string }
> = {
  blue: {
    firstBoxClassNames: 'from-accent to-[#6DBEFF] shadow-[0_5px_20px_#0A78E68C_inset]',
    secondBoxClassNames: 'bg-[#349EFF]',
  },
  orange: {
    firstBoxClassNames: 'from-[#FF902A] to-[#FFCF97] shadow-[0_5px_20px_#FAB54D_inset]',
    secondBoxClassNames: 'bg-[#FFE3C9]',
  },
};

export function ImageWithBackground({ variant, children }: ImageWithBackgroundProps) {
  const { firstBoxClassNames, secondBoxClassNames } = VARIANT_TO_STYLES_MAP[variant];

  return (
    <div className="relative size-fit">
      <div
        className={cn(
          'absolute right-0 top-2 size-[calc(100%-12px)] rounded-[14px] border-b border-r border-[#ffffff55] bg-linear-to-b',
          firstBoxClassNames
        )}
      />
      <div
        className={cn(
          'absolute right-2 top-4 size-[calc(100%-16px)] rounded-[14px]',
          secondBoxClassNames
        )}
      />
      <div className="relative">{children}</div>
    </div>
  );
}
